import { render, staticRenderFns } from "./LandingBody.vue?vue&type=template&id=bf86d19e&scoped=true&"
import script from "./LandingBody.vue?vue&type=script&lang=js&"
export * from "./LandingBody.vue?vue&type=script&lang=js&"
import style0 from "./LandingBody.vue?vue&type=style&index=0&id=bf86d19e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf86d19e",
  null
  
)

export default component.exports